export default __webpack_public_path__ + "static/timeportals2-0cf6783e50a7678d33f36be048b274ff.png";